import React from 'react';
import Theme from '../Theme';
import CenteredContent from 'src/components/Section/CenteredContent';
import { mediaQueries } from 'src/style/breakpoints';

/**
 * @type React.FunctionComponent<{ theme?: string; className?: string; hero?: boolean, marginTop?: number, FAQSection?: boolean }>
 */
const FAQWhiteBG = ({ children, theme, className = '', marginTop }) => {
  return (
    <Theme theme={theme}>
      <div
        className={className}
        css={theme => ({
          backgroundColor: theme.backgroundColor,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        })}
      >
        <div
          css={theme => ({
            backgroundColor: theme.backgroundColor,
            marginTop: marginTop,
            paddingTop: 8,
            paddingBottom: 110,
            maxWidth: 1302,
            borderRadius: 5,
            position: 'relative',
            [mediaQueries.phoneOnly]: {
              paddingTop: 0,
              paddingBottom: 55,
              width: '100vw',
            },
          })}
        >
          <CenteredContent
            css={{
              [mediaQueries.desktopUp]: {
                padding: '0 68px',
              },
            }}
          >
            {children}
          </CenteredContent>
        </div>
      </div>
    </Theme>
  );
};

export default FAQWhiteBG;
